import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/layouts/Login.vue'
import AppLayout from '@/layouts/App.vue'
import Toast from "vue-toastification";
import { isLoggedIn } from '@/auth'


// Customers
import Relationships from '@/layouts/relationships/Relationships.vue'
import RelationshipsOverview from '@/layouts/relationships/RelationshipsOverview.vue'
import RelationshipsContactNew from '@/layouts/relationships/RelationshipsNewContact.vue'
import RelationshipsContactEdit from '@/layouts/relationships/RelationshipsEditContact.vue'
import RelationshipsAddresses from '@/layouts/relationships/RelationshipsAddresses.vue'
import RelationshipsAddressesNew from '@/layouts/relationships/RelationshipsAddressesNew.vue'
import RelationshipsAddressesEdit from '@/layouts/relationships/RelationshipsAddressesEdit.vue'
import RelationshipsOrders from '@/layouts/relationships/RelationshipsOrders.vue'
import RelationshipsNew from '@/layouts/relationships/RelationshipsNew.vue'
import RelationshipsEditCompany from '@/layouts/relationships/RelationshipsEdit.vue'
import RelationshipsAssets from '@/layouts/relationships/RelationshipsAssets.vue'
import RelationshipsNotes from '@/layouts/relationships/RelationshipsNotes.vue'
import RelationshipsRiskAssesments from '@/layouts/relationships/RelationshipsRiskAssesments.vue'
import RelationshipsAssetNew from '@/layouts/relationships/RelationshipsAssetNew.vue'
import RelationshipsTempCalibrations from '@/layouts/relationships/RelationshipsTempCalibrations.vue'

// Orders
import Orders from '@/layouts/orders/Orders.vue'
import OrdersNew from '@/layouts/orders/OrdersNew.vue'
import OrdersView from '@/layouts/orders/OrdersView.vue'
import OrdersEdit from '@/layouts/orders/OrdersEdit.vue'
import MaintenanceEdit from '@/layouts/orders/MaintenanceNew.vue'
import OrdersRefridgerationEdit from '@/layouts/orders/RefridgerationMaintenance.vue'
import OrdersAirconEdit from '@/layouts/orders/Aircon.vue'


// Assets
import AssetsEdit from '@/layouts/assets/AssetEdit.vue'
import AssetsJobs from '@/layouts/assets/AssetJobs.vue'
import AssetsLeak from '@/layouts/assets/AssetLeak.vue'
import AssetsFgas from '@/layouts/assets/AssetFgas.vue'
import AssetsLeakEdit from '@/layouts/assets/AssetLeakEdit.vue'
import AssetsFgasAdd from '@/layouts/assets/AssetFgasAdd.vue'
import AssetsFgasEdit from '@/layouts/assets/AssetFgasEdit.vue'


Vue.use(Toast);
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { guestOnly: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    components: {
      default: AppLayout
      // leftnav: LeftNav,
      // topnav: TopNav
    },
    meta: { authOnly: true }
    // component: AppLayout
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/Dashboard.vue')
  },
  
  {
    path: '/relationships',
    name: 'Relationships',
    component: Relationships,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/new',
    name: 'RelationshipsNew',
    component: RelationshipsNew,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id',
    name: 'RelationshipsEdit',
    component: RelationshipsOverview,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/edit',
    name: 'RelationshipsEditCompany',
    component: RelationshipsEditCompany,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/addresses',
    name: 'RelationshipsAddress',
    component: RelationshipsAddresses,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/addresses/new',
    name: 'RelationshipsAddressNew',
    component: RelationshipsAddressesNew,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/addresses/:aid',
    name: 'RelationshipsAddressesEdit',
    component: RelationshipsAddressesEdit,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/contact/new',
    name: 'RelationshipsContactNew',
    component: RelationshipsContactNew,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/contact/:cid',
    name: 'RelationshipsContactEdit',
    component: RelationshipsContactEdit,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/notes',
    name: 'RelationshipsNotes',
    component: RelationshipsNotes,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/orders',
    name: 'RelationshipsOrders',
    component: RelationshipsOrders,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/assets',
    name: 'RelationshipsAssets',
    component: RelationshipsAssets,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/assets/new',
    name: 'RelationshipsAssetNew',
    component: RelationshipsAssetNew,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/risk-assessments',
    name: 'RelationshipsRiskAssesments',
    component: RelationshipsRiskAssesments,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/relationships/:id/temperature-calibrations',
    name: 'RelationshipsTempCalibrations',
    component: RelationshipsTempCalibrations,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/jobs',
    name: 'Orders',
    params: { type: 'all'},
    component: Orders,
    meta: { authOnly: true, navName: 'Jobs' }
  },
  {
    path: '/jobs/new',
    name: 'OrdersNew',
    component: OrdersNew,
    meta: { authOnly: true, navName: 'Jobs' }
  },
  {
    path: '/jobs/:id',
    name: 'OrdersView',
    component: OrdersView,
    meta: { authOnly: true, navName: 'Jobs' }
  },
  {
    path: '/jobs/:id/edit',
    name: 'OrdersEdit',
    component: OrdersEdit,
    meta: { authOnly: true, navName: 'Jobs' }
  },
  {
    path: '/jobs/:id/edit/refridgeration',
    name: 'OrdersRefridgerationEdit',
    component: OrdersRefridgerationEdit,
    meta: { authOnly: true, navName: 'Jobs' }
  },
  {
    path: '/jobs/:id/edit/maintenance',
    name: 'MaintenanceEdit',
    component: MaintenanceEdit,
    meta: { authOnly: true, navName: 'Jobs' }
  },
  {
    path: '/jobs/:id/edit/aircon',
    name: 'OrdersAirconEdit',
    component: OrdersAirconEdit,
    meta: { authOnly: true, navName: 'Jobs' }
  },
  {
    path: '/assets/:id',
    name: 'AssetsEdit',
    component: AssetsEdit,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/assets/:id/jobs',
    name: 'AssetsJobs',
    component: AssetsJobs,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/assets/:id/leak_checks',
    name: 'AssetsLeak',
    component: AssetsLeak,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/assets/:id/fgas',
    name: 'AssetsFgas',
    component: AssetsFgas,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/assets/:id/leak_checks/:aid',
    name: 'AssetsLeakEdit',
    component: AssetsLeakEdit,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  {
    path: '/assets/:id/fgas/add',
    name: 'AssetsFgasAdd',
    component: AssetsFgasAdd,
    meta: { authOnly: true, navName: 'Relationships' }
  },
   {
    path: '/assets/:id/fgas/:aid',
    name: 'AssetsFgasEdit',
    component: AssetsFgasEdit,
    meta: { authOnly: true, navName: 'Relationships' }
  },
  
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// Every page needs a signed-in user except the login page (meta.guestOnly).
router.beforeEach((to, from, next) => {
  const guestOnly = to.matched.some(record => record.meta.guestOnly)

  if (!guestOnly && !isLoggedIn()) {
    next({ name: 'Home', query: { redirect: to.fullPath } })
  } else if (guestOnly && isLoggedIn()) {
    next({ name: 'Orders' })
  } else {
    next()
  }
})

export default router
